import { Routes } from '@angular/router';
import { authGuard, NotFoundComponent } from '@absti/ng-lib';
import { PROTO_PUBLIC_ROUTES, PROTO_SHELL_ROUTES } from './proto/navigation/proto.routes';
import { roleGuard, treeChosenGuard } from './proto/session/role.guard';

export const routes: Routes = [
  // ── Public routes ─────────────────────────────────────────────
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'resetPassword',
    loadComponent: () =>
      import('./components/reset-password/reset-password.component').then(
        m => m.ResetPasswordComponent,
      ),
  },

  {
    path: 'registro',
    loadComponent: () =>
      import('./proto/screens/session/register.page').then(m => m.RegisterPage),
  },

  // P-03: outside the shell, so choosing a tree always starts the shell from scratch
  {
    path: 'elegir-arbol',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./proto/screens/session/tree-picker.page').then(m => m.TreePickerPage),
  },

  // E-01 / E-02: end-client pages, outside the shell and without guard
  ...PROTO_PUBLIC_ROUTES,

  // ── Protected routes (under HomeComponent shell) ──────────────
  {
    path: '',
    loadComponent: () =>
      import('./components/home/home.component').then(m => m.HomeComponent),
    canActivate: [authGuard, treeChosenGuard],
    children: [
      // Prototype screens (P-xx), one stub per screen; guarded by role
      ...PROTO_SHELL_ROUTES,

      // D-006-fe: pre-prototype admin screens, reachable by the admin role only
      {
        path: '',
        canActivate: [roleGuard],
        data: { roles: ['admin'] },
        children: [
          // 10 library integration routes (lazy-loaded from @absti/ng-lib/*)
          {
            path: 'security',
            loadChildren: () =>
              import('@absti/ng-lib/security').then(m => m.SECURITY_ROUTES),
          },
          {
            path: 'properties',
            loadChildren: () =>
              import('@absti/ng-lib/properties').then(m => m.PROPERTIES_ROUTES),
          },
          {
            path: 'jobs',
            loadChildren: () =>
              import('@absti/ng-lib/jobs').then(m => m.JOBS_ROUTES),
          },
          {
            path: 'workflows',
            loadChildren: () =>
              import('@absti/ng-lib/workflow').then(m => m.WORKFLOW_ROUTES),
          },
          {
            path: 'mails',
            loadChildren: () =>
              import('@absti/ng-lib/mails').then(m => m.MAILS_ROUTES),
          },
          {
            path: 'storage',
            loadChildren: () =>
              import('@absti/ng-lib/storage').then(m => m.STORAGE_ROUTES),
          },
          {
            path: 'logging',
            loadChildren: () =>
              import('@absti/ng-lib/observability').then(
                m => m.OBSERVABILITY_ROUTES,
              ),
          },
          {
            path: 'cache',
            loadChildren: () =>
              import('@absti/ng-lib/cache').then(m => m.CACHE_ROUTES),
          },
          {
            path: 'events',
            loadChildren: () =>
              import('@absti/ng-lib/events').then(m => m.EVENTS_ROUTES),
          },
          {
            path: 'tenants',
            loadChildren: () =>
              import('@absti/ng-lib/tenant').then(m => m.TENANT_ROUTES),
          },

          // App-specific routes
          {
            path: 'usuarios/new',
            loadComponent: () =>
              import('./components/usuarios-create/usuarios-create.component').then(
                m => m.UsuariosCreateComponent,
              ),
          },
          {
            path: 'usuarios/:id/edit',
            loadComponent: () =>
              import('./components/usuarios-edit/usuarios-edit.component').then(
                m => m.UsuariosEditComponent,
              ),
          },
          {
            path: 'usuarios',
            loadComponent: () =>
              import('./components/usuarios/usuarios.component').then(
                m => m.UsuariosComponent,
              ),
          },
          {
            path: 'usuarios/:id',
            loadComponent: () =>
              import('./components/usuarios-view/usuarios-view.component').then(
                m => m.UsuariosViewComponent,
              ),
          },
          {
            path: 'service-accounts/new',
            loadComponent: () =>
              import('./components/service-accounts-create/service-accounts-create.component').then(
                m => m.ServiceAccountsCreateComponent,
              ),
          },
          {
            path: 'service-accounts',
            loadComponent: () =>
              import('./components/service-accounts/service-accounts.component').then(
                m => m.ServiceAccountsComponent,
              ),
          },
          {
            path: 'branding',
            loadComponent: () =>
              import('./components/branding/branding.component').then(
                m => m.BrandingComponent,
              ),
          },
        ],
      },

      {
        path: 'misDatos',
        loadComponent: () =>
          import('./components/mis-datos/mis-datos.component').then(
            m => m.MisDatosComponent,
          ),
      },
      {
        path: 'changePwd',
        loadComponent: () =>
          import('./components/change-password/change-password.component').then(
            m => m.ChangePasswordComponent,
          ),
      },
    ],
  },

  // ── Catch-all ──────────────────────────────────────────────────
  { path: '**', component: NotFoundComponent },
];
